export default __webpack_public_path__ + "static/media/failed.d0a2b515.svg";